import { isNative, isAndroid } from '@shared/utils/platform';
import { App } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Browser } from '@capacitor/browser';
import { CapacitorUpdater } from '@capgo/capacitor-updater';

if (isNative) {
  // Critical: tells Capgo the new bundle booted successfully. Without this,
  // Capgo rolls back to the previous version after a few launches.
  CapacitorUpdater.notifyAppReady().catch(() => {});
  // Attach deep link listener synchronously before any async work so scheme
  // redirects after Browser.open() are always captured.
  App.addListener('appUrlOpen', async ({ url }) => {
    console.log('[capacitor] appUrlOpen:', url);
    await Browser.close().catch(() => {});

    // Custom scheme: loudneighbors://callback?code=... → host=callback, search=?code=...
    // (the staging app uses loudneighbors-staging://, so match any non-web scheme)
    // Universal Link: https://app.loudneighbors.com/callback?code=... → pathname=/callback
    const parsed = new URL(url);
    let path;
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      path = `/${parsed.hostname}${parsed.pathname === '/' ? '' : parsed.pathname}${parsed.search}`;
    } else {
      path = parsed.pathname + parsed.search;
    }
    console.log('[capacitor] navigating to:', path);
    window.location.replace(path);
  });

  if (isAndroid) {
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });
  }

  // Left-edge swipe to go back (stopgap until native allowsBackForwardNavigationGestures ships)
  let swipeStartX = null;
  let swipeStartY = null;
  window.addEventListener('touchstart', (e) => {
    const t = e.touches[0];
    if (t.clientX < 20) {
      swipeStartX = t.clientX;
      swipeStartY = t.clientY;
    } else {
      swipeStartX = null;
    }
  }, { passive: true });
  window.addEventListener('touchend', (e) => {
    if (swipeStartX === null) return;
    const t = e.changedTouches[0];
    const dx = t.clientX - swipeStartX;
    const dy = Math.abs(t.clientY - swipeStartY);
    if (dx > 70 && dy < 60 && window.history.length > 1) {
      window.history.back();
    }
    swipeStartX = null;
  }, { passive: true });

  StatusBar.setStyle({ style: Style.Light }).catch(() => {});
  StatusBar.setOverlaysWebView({ overlay: true }).catch(() => {});

  // Splash is hidden by LNAuthContext once the initial auth check completes.
  // Fallback in case something goes wrong and it never hides.
  setTimeout(() => SplashScreen.hide().catch(() => {}), 4000);
}
